var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notes fade-in"},[_c('TextAreaField',{attrs:{"label":"Notes","showLabel":false,"rows":"8"},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }